const formatResultsSection = (
    results: Record<string, string>,
    title: string,
    contextText: string,
    truncatedContextText: string
): { contextText: string; truncatedContextText: string } => {
    const formattedResults = Object.entries(results)
        .map(([_, value]) => `${value}`)
        .join('\n');

    return {
        contextText: contextText + `\n${title}:\n"""\n${formattedResults}\n"""\n`,
        truncatedContextText: truncatedContextText + `${title}:\n"""\n<Truncated for brevity>\n"""\n`
    };
};

const formatSearchResultsSection = (
    results: Record<string, { name: string; text?: string; engine?: string; }>,
    title: string,
    contextText: string,
    truncatedContextText: string
): { contextText: string; truncatedContextText: string } => {
    const formattedResults = Object.entries(results)
        .map(([url, result]) => {
            let resultString = `Title: ${result.name}\nURL: ${url}`;

            if (result.engine) {
                resultString += `\nEngine: ${result.engine}`;
            }

            if (result.text) {
                resultString += `\nContent:\n\`\`\`\n${result.text}\n\`\`\``;
            }

            return resultString;
        })
        .join('\n\n');

    return {
        contextText: contextText + `\n${title}:\n"""\n${formattedResults}\n"""\n`,
        truncatedContextText: truncatedContextText + `${title}:\n"""\n<Truncated for brevity>\n"""\n`
    };
};

export const gatherContext = (toolMessage: any, results: any) => {
    let contextText = ``;
    let truncatedContextText = ``;

    if (!results.chronologicalEvents || results.chronologicalEvents.length === 0) {
        contextText = "<No context gathered>";
        truncatedContextText = "<No context gathered>";
    }
    else {
        if (results.fileResults && Object.keys(results.fileResults).length > 0) {
            const formatted = formatResultsSection(
                results.fileResults,
                "Here are the files and their contents that were retrieved",
                contextText,
                truncatedContextText
            );
            contextText = formatted.contextText;
            truncatedContextText = formatted.truncatedContextText;
        }

        if (results.searchResults && Object.keys(results.searchResults).length > 0) {
            const formatted = formatSearchResultsSection(
                results.searchResults,
                "Here are the search results that were retrieved",
                contextText,
                truncatedContextText
            );
            contextText = formatted.contextText;
            truncatedContextText = formatted.truncatedContextText;
        }

        // Add encountered resources section
        const resources = [];
        if (results.seenFilePathsArr && results.seenFilePathsArr.length > 0) {
            resources.push(`Files encountered: ${results.seenFilePathsArr.join(', ')}`);
        }
        if (resources.length > 0) {
            contextText += `\n\n\nResources encountered during context gathering:\n${resources.join('\n')}\n`;
        }

        contextText += `\n\n\nProvide citations in the format of [<name>](<url>). Link images with ![<name>](<url>).`;
    }

    const content = [{
        type: 'text',
        text: contextText
    }];
    const truncatedContent = [{
        type: 'text',
        text: truncatedContextText
    }];

    return {...toolMessage, content: content, truncatedContent: truncatedContent};
}
